<style></style>
<template>
  <div class="modal fade" id="modalFactura" role="dialog" tabindex="-1" aria-hidden="true" style="display: auto">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Factura</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <form @submit="agregarFactura">
          <div class="modal-body text-left">
            <div class="form-group">
              <label v-bind:class="{
                'text-danger':
                  factura.errors.fecha_documento &&
                  factura.errors.fecha_documento.length > 0,
              }">Fecha Documento</label>
              <datepicker :format="'dd/MM/yyyy'" :bootstrap-styling="true" v-bind:class="{
                'is-invalid':
                  factura.errors.fecha_documento &&
                  factura.errors.fecha_documento.length > 0,
              }" v-model="factura.fecha_documento"></datepicker>
              <small v-if="factura.errors && factura.errors.fecha_documento" class="form-text text-danger">{{
                factura.errors.fecha_documento[0] }}</small>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      factura.errors.serie && factura.errors.serie.length > 0,
                  }">Serie:</label>
                  <input v-model="factura.serie" class="form-control" placeholder="Serie" v-bind:class="{
                    'is-invalid':
                      factura.errors.serie && factura.errors.serie.length > 0,
                  }" type="text" />
                  <small v-if="factura.errors && factura.errors.serie" class="form-text text-danger">{{
                    factura.errors.serie[0] }}</small>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      factura.errors.documento &&
                      factura.errors.documento.length > 0,
                  }"># Factura:</label>
                  <input v-model="factura.documento" class="form-control" placeholder="# Factura" v-bind:class="{
                    'is-invalid':
                      factura.errors.documento &&
                      factura.errors.documento.length > 0,
                  }" type="text" />
                  <small v-if="factura.errors && factura.errors.documento" class="form-text text-danger">{{
                    factura.errors.documento[0] }}</small>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label v-bind:class="{
                    'text-danger':
                      factura.errors.total_documento &&
                      factura.errors.total_documento.length > 0,
                  }">Total:</label>
                  <input v-model="factura.total_documento" class="form-control" placeholder="Total" v-bind:class="{
                    'is-invalid':
                      factura.errors.total_documento &&
                      factura.errors.total_documento.length > 0,
                  }" type="number" step="0.01" />
                  <small v-if="factura.errors && factura.errors.total_documento" class="form-text text-danger">{{
                    factura.errors.total_documento[0] }}</small>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" type="submit">
              <span v-if="factura.id == null">Crear <i class="fas fa-plus"></i></span>

              <span v-if="factura.id != null">Editar <i class="fas fa-edit"></i></span>
            </button>
            <button class="btn btn-danger" data-dismiss="modal" type="button" ref="cerrarModalFactura">
              Cancelar <i class="fa fa-times"></i>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      factura: {
        id: null,
        fecha_documento: null,
        serie: "",
        documento: "",
        total_documento: null,
        archivo: null,
        errors: {
          fecha_documento: null,
          serie: "",
          documento: "",
          total_documento: null,
          archivo: null,
        },
      },
    };
  },
  computed: {},
  props: {
    recepcion: {
      type: Object,
      required: true,
    },
    factura_id: {
      type: String,
      required: false,
    },
  },
  mounted() {
    let self = this;
  },
  watch: {
    factura_id: function () {
      let self = this;
      if (self.factura_id != null) {
        DynamicService.getById("wms", "facturas", self.factura_id).then(
          (response) => {
            self.factura = Object.assign(self.factura, response.data);
          }
        );
      } else {
        self.factura = {
          id: null,
          fecha_documento: null,
          serie: "",
          documento: "",
          total_documento: null,
          archivo: null,
          errors: {
            fecha_documento: null,
            serie: "",
            documento: "",
            total_documento: null,
            archivo: null,
          },
        };
      }
    },
  },
  methods: {
    cleanDataFactura() {
      let self = this;
      self.factura.id = null;
      self.factura.fecha_documento = null;
      self.factura.serie = "";
      self.factura.documento = "";
      self.factura.fecha_documento = null;
      self.factura.total_documento = null;
    },
    agregarFactura(e) {
      let self = this;
      e.preventDefault();
      let params = Object.assign({}, self.factura);
      if (params.id == null) {
        delete params.id;
      }
      if (params.fecha_documento) {
        params.fecha_documento = moment(params.fecha_documento).format(
          "DD/MM/YYYY"
        );
      }
      if ("id" in params) {
        DynamicService.save("wms", "facturas", params)
          .then((res) => {
            self.cleanDataFactura();
            self.$refs.cerrarModalFactura.click();
            this.$emit("refresh", {});
          })
          .catch((error) => {
            if (error) {
              self.factura.errors = error.response.data;
              if ("detail" in error.response.data) {
                Notifications.alert.error(
                  "Abrir Transaccion",
                  error.response.data.detail
                );
              }
            }
          });
      } else {
        DynamicService.postAction(
          "wms",
          "recepcion",
          self.recepcion.id,
          "agregar_factura",
          params
        )
          .then((res) => {
            self.cleanDataFactura();
            self.$refs.cerrarModalFactura.click();
            this.$emit("refresh", {});
          })
          .catch((error) => {
            if (error) {
              self.factura.errors = error.response.data;
              if ("detail" in error.response.data) {
                Notifications.alert.error(
                  "Abrir Transaccion",
                  error.response.data.detail
                );
              }
            }
          });
      }
    },
  },
};
</script>
